import _reduce from 'lodash/reduce';
import _pickBy from 'lodash/pickBy';
import _forIn from 'lodash/forIn';
import {
  ENG_BUBBLE_CHART,
  ENG_INIT,
  ENG_MOVE_CHART,
  ENG_RESIZE_CHART,
  ENG_SEND_WORK_AREA_SUCCESS,
  ENG_TOGGLE_GRAPHICS_SUCCESS,
  ENG_SET_GRAPHICS_STATUS,
  ENG_UPDATE_SKETCHER_SUCCESS,
} from '../../constants/engineering';
import { SIMULATION_START_SUCCESS } from '../../constants/simulation';
import { STATUS_OFF } from '../../constants/common';

export const defaultState = {
  charts: {}, // object of charts, indexed by chart id
  coords: {}, // object of chart coordinates, indexed by chart id - these are kept even after a chart has been removed
};

/**
 * Adds new charts and/or removes charts by node name if the graphics have been turned off for a node
 *
 * @param current
 * @param source
 * @returns object
 */
function mergeCharts(current, source) {
  return _reduce(
    source,
    (accu, graphics, node) => {
      if (graphics.status === STATUS_OFF || graphics.status === 'off') {
        return _pickBy(accu, (chart) => chart.node !== node);
      } else if (graphics.charts) {
        const newCharts = graphics.charts.reduce((byKey, newChart) => {
          byKey[newChart.id] = newChart;
          byKey[newChart.id].node = node;
          return byKey;
        }, {});
        return { ...accu, ...newCharts };
      } else {
        return accu;
      }
    },
    current || {}
  );
}

function bubbleZ(coords, chartId, x = null, y = null) {
  let size = undefined;
  if (coords[chartId]) {
    x = x || coords[chartId].x;
    y = y || coords[chartId].y;
    size = coords[chartId].size;
  }
  coords[chartId] = { x, y, z: -1, size };

  let nextZ = Object.keys(coords).length;
  _forIn(coords, (c) => {
    if (c.hasOwnProperty('z')) {
      c.z++;
    } else {
      c.z = ++nextZ;
    }
  });

  return coords;
}

const charts = (state = defaultState, action) => {
  switch (action.type) {
    case ENG_INIT:
      if (action.data.graphics) {
        return {
          ...state,
          charts: mergeCharts(state.charts, action.data.graphics),
        };
      } else {
        return state;
      }
    case ENG_SEND_WORK_AREA_SUCCESS:
    case ENG_TOGGLE_GRAPHICS_SUCCESS:
    case ENG_UPDATE_SKETCHER_SUCCESS:
    case SIMULATION_START_SUCCESS:
      if (action.result && action.result.graphics) {
        return {
          ...state,
          charts: mergeCharts(state.charts, action.result.graphics),
        };
      } else if (action.result && action.result.charts) {
        return {
          ...state,
          charts: Object.fromEntries(
            action.result.charts.map((c) => [c.id, c])
          ),
        };
      } else {
        return state;
      }
    case ENG_SET_GRAPHICS_STATUS:
      if (action.node) {
        // look for the chart where node = action.node
        return {
          ...state,
          charts: mergeCharts(state.charts, {
            [action.node]: {
              status: action.status,
            },
          }),
        };
      }
      return state;
    case ENG_MOVE_CHART:
      return {
        charts: state.charts,
        coords: bubbleZ(state.coords, action.chartId, action.x, action.y),
      };
    case ENG_BUBBLE_CHART:
      return {
        charts: state.charts,
        coords: bubbleZ(state.coords, action.chartId),
      };
    case ENG_RESIZE_CHART:
      return {
        charts: state.charts,
        coords: {
          ...state.coords,
          [action.chartId]: {
            ...state.coords[action.chartId],
            size: action.size,
          },
        },
      };
    default:
      return state;
  }
};

export default charts;
